export const initialState = {
  myExperience: [],
  allExperience: [],
  basketExperienceIds: [],
  auctionExperience: [],
  auctionExperienceIds: [],
  dealDoneExperience: [],
  wonExperience: [],
  lostExperience: [],
  editExperience: undefined,
  experienceDetails: undefined,
  experienceDetailsId: '',
  customTime: undefined,
  timeStamp: undefined
};

export default function experienceReducer(state = initialState, action) {
  switch (action.type) {
    case 'EXPERIENCE_FIND_ALLEXPERIENCE': {
      if (action.data) {
        const allExperience = action.data.allExperience;

        return {
          ...state,
          allExperience: allExperience
        };
      }
      return initialState;
    }
    case 'EXPERIENCE_SET_EDITEXPERIENCE': {
      if (action.data) {
        const editExperience = action.data;

        return {
          ...state,
          editExperience: editExperience
        };
      }
      return initialState;
    }
    case 'EXPERIENCE_SET_EXPERIENCEDETAILSID': {
      if (action.data) {
        const id = action.data;
        return {
          ...state,
          experienceDetailsId: id
        };
      }
      return initialState;
    }
    default:
      return state;
  }
}
